
import React from 'react';
import { Profession } from '@/lib/professionTypes';
import { Checkbox } from "@/components/ui/checkbox";
import { getCategoryIcon } from './ProfessionUtils';

interface ProfessionCategoryGroupProps {
  category: string;
  professions: Profession[];
  selectedProfessions: string[];
  onProfessionChange: (professionId: string, checked: boolean) => void;
}

const ProfessionCategoryGroup: React.FC<ProfessionCategoryGroupProps> = ({
  category,
  professions,
  selectedProfessions,
  onProfessionChange
}) => {
  const Icon = getCategoryIcon(category);
  
  return (
    <div key={category} className="space-y-2">
      <h4 className="text-sm font-medium flex items-center gap-1.5 text-muted-foreground">
        <Icon className="h-4 w-4" />
        {category}
      </h4>
      <div className="space-y-1 ml-2">
        {professions.map(profession => (
          <div key={profession.id} className="flex items-start space-x-2">
            <Checkbox
              id={`profession-${profession.id}`}
              checked={selectedProfessions.includes(profession.id)}
              onCheckedChange={(checked) => {
                onProfessionChange(profession.id, !!checked);
              }}
            />
            <label
              htmlFor={`profession-${profession.id}`}
              className="text-sm leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 cursor-pointer"
            >
              {profession.name}
            </label>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProfessionCategoryGroup;
